import React from 'react';
import './style.scss'
import { Link } from 'react-router-dom'

import Menu from '../../components/Menu'
// import Body from '../../components/Body'
import Footer from '../../components/Footer'


import ImgWebshoppersFree from '../../assets/imagens/webshoppers/Capa-WB43Free.PNG'
import ImgWebshoppersPremium from '../../assets/imagens/webshoppers/Capa-WB43Premium.PNG'
import ImgWebshoppersCustom from '../../assets/imagens/webshoppers/Capa-WB43Capitulos.PNG'

import ImgBannerWebshoppers42 from '../../assets/imagens/01_Bexs_logo_tagline_secundario_transp_RGB.png'
import ImgBannerWebshoppers43Benx from '../../assets/imagens/01_Bexs_logo_tagline_preferencial_RGB.png'

import ImgWsOldCuston from '../../assets/imagens/webshoppers/Webshopper-Custom-42.3f364dbc.JPG'
import ImgWsOldPremium from '../../assets/imagens/webshoppers/Webshopper-Premium-42.4ee37b6a.JPG'

import ImgBannerFooter from '../../assets/imagens/img-shopper01.ad471829.jpg'


function Webshoppers() {


  return (
    <>
      <Menu></Menu>

      <div className="banner-webshoppers">
        <div className="banner-webshoppers__text-bn-ws-43 container">

          <div className="descripition-ws-43">
            <h1>43ª ed.</h1>
            <h1>Webshoppers</h1>
          </div>

          <div className="">
            <img src={ImgBannerWebshoppers42} alt="Logo bexs" />
          </div>

        </div>



      </div>

      <div className="webshoppers-plan container">
        <h2>Confira as novas versões</h2>
        <div className="webshoppers-plan__pricing">
          <a href="https://company.ebit.com.br/webshoppers/webshoppersfree" className="webshoppers-plan__pricing__content">
            <img src={ImgWebshoppersFree} alt="" />
            <h3>Free </h3>
            <div className="value-report">
              <p><span>R$</span> 0</p>
            </div>
            <div>
              <p>
                Versão geral do relatório com as principais
                movimentações do <br /><b>E-commerce</b> em 2020
                versus 2019.
              </p>
            </div>

          </a>

          <Link to="/webshoppers-premium" className="webshoppers-plan__pricing__content">
            <img src={ImgWebshoppersPremium} alt="" />
            <h3>Premium </h3>
            <div className="value-report">
              <p><span>R$</span> 38.064,67</p>
            </div>
            <div>
              <ul>
                <li> <span className="fa fa-check-square-o" aria-hidden="true"></span> Overview do <b>E-commerce</b></li>
                <li> <span className="fa fa-check-square-o" aria-hidden="true"></span> Novos <b>Consumidores</b></li>
                <li> <span className="fa fa-check-square-o" aria-hidden="true"></span> Datas <b>Sazonais</b></li>
                <li> <span className="fa fa-check-square-o" aria-hidden="true"></span> Cross Border<b>Trade</b></li>
              </ul>
            </div>

          </Link>

          <Link to="/webshoppers-capitulos" className="webshoppers-plan__pricing__content">
            <img src={ImgWebshoppersCustom} alt="" />
            <h3>Capítulos Individuais</h3>
            <div className="value-report">
              <p>Consulte</p>
            </div>
            <div>
              <ul>
                <li> <span className="fa fa-check-square-o" aria-hidden="true"></span> Overview do <b>E-commerce</b></li>
                <li> <span className="fa fa-check-square-o" aria-hidden="true"></span> Novos <b>Consumidores</b></li>
                <li> <span className="fa fa-check-square-o" aria-hidden="true"></span> Datas <b>Sazonais</b></li>
                <li> <span className="fa fa-check-square-o" aria-hidden="true"></span> Cross Border<b>Trade</b></li>
              </ul>
            </div>

          </Link>

        </div>
      </div>
      <hr />



      <div className="ws-descripition container">
        <h2>O que é o Webshoppers</h2>

        <p className="lead">Realizado pela Ebit desde 2001, o Webshoppers é o <strong>relatório de maior credibilidade sobre o comércio eletrônico brasileiro</strong> e considerado a principal referência para os profissionais do segmento.</p>

        <p className="lead">Neste estudo, serão apresentados o cenário atual do mercado de e-commerce, as estimativas para 2020, bem como as mudanças de comportamento e preferências dos consumidores. Os insights obtidos pela pesquisa visam <strong>traçar o rumo do mercado de compras online e contribuir para o entendimento e desenvolvimento do setor.</strong></p>

      </div>


      <div className="img-footer-ws-43 container">
        <img src={ImgBannerFooter} alt="Banner Medalhas" />
      </div>



      <div className="patrocinador-ws-43 container">
        <div>
          <p>O 43º Webshoppers tem a parceria do</p>
          <img src={ImgBannerWebshoppers43Benx} alt="Logo Benx" />
        </div>
        <p className="lead">
          O Bexs Banco oferece uma plataforma única que integra pagamentos locais e câmbio (FX), e assim conecta milhões de pessoas e negócios do Brasil e do mundo. Por meio de APIs exclusivas, nossa solução oferece uma experiência de pagamento totalmente local, proporcionando que grandes e pequenas empresas acessem clientes digitalmente e expandam geograficamente suas fronteiras.
        </p>
      </div>



      <div className="ws-vs-42 container">
        <h2>
          Versão anterior
        </h2>

        <div className="old-reports-layout">

          <div className="reports-vs-42">
            <img src={ImgWsOldPremium} alt="" />
            <h4>Premium</h4>
            <p className="old-pricing"><span>R$</span> 15.854,41</p>
            <a href="https://pay.ebit.com.br/products/webshoppers-42-premium" className="pay-old-report">Comprar</a>
          </div>

          <div className="reports-vs-42">
            <img src={ImgWsOldCuston} alt="" />
            <h4>E-commerce no Brasil</h4>
            <p className="old-pricing"><span>R$</span> 6.341,76 </p>
            <a href="https://pay.ebit.com.br/products/webshoppers-42-ecommerce-no-brasil" className="pay-old-report">Comprar</a>
          </div>

          <div className="reports-vs-42">
            <img src={ImgWsOldCuston} alt="" />
            <h4>Tipos de operações</h4>
            <p className="old-pricing"><span>R$</span> 6.341,76 </p>
            <a href="https://pay.ebit.com.br/products/webshoppers-42-tipos-de-operacoes-e-marketplace" className="pay-old-report">Comprar</a>
          </div>

          <div className="reports-vs-42">
            <img src={ImgWsOldCuston} alt="" />
            <h4>Aplicativos de entrega</h4>
            <p className="old-pricing"><span>R$</span> 6.341,76 </p>
            <a href="https://pay.ebit.com.br/products/webshoppers-42-aplicativos-de-entrega" className="pay-old-report">Comprar</a>
          </div>

        </div>
      </div>



      <Footer></Footer>
    </>
  );
}

export default Webshoppers;